module.exports = __webpack_public_path__ + "assets/htu-12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HTU-modal/htu-12.jpg
// module id = 1199
// module chunks = 7